// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".logo[data-v-ec942a1c]{margin-bottom:3rem}.complete-instructions[data-v-ec942a1c]{display:block;margin-bottom:.5rem;font-size:1.2rem}.close-instructions[data-v-ec942a1c]{padding:1rem 0;border-top:1px solid #ccc}.responsive-img[data-v-ec942a1c]{height:auto;max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
